import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MessageDialogService } from '../../services/message-dialog';
import { SelectedProduct } from '../../services/products';
import { firstValueFrom } from 'rxjs';
import { CustomerService, Customer } from '../../services/customer';
import { FilteredLoad, LoadDetail, LoadManagementService } from '../../services/load-management.service';
import { MatIconModule } from '@angular/material/icon';
import { LoadViewerComponent } from '../../components/load-viewer-component/load-viewer-component';
import { LoadTableComponent } from '../../components/load-table-component/load-table-component';

@Component({
  selector: 'app-load-report',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    LoadViewerComponent,
    LoadTableComponent
  ],
  templateUrl: './load-report-component.html',
  styleUrls: ['./load-report-component.scss']
})
export class LoadReportComponent {
  startDate: string = '';
  endDate: string = '';
  page: number = 1;
  pageSize: number = 10;
  totalPages: number = 1;

  loads: FilteredLoad[] = [];
  showCart = false;

  selectedLoad: LoadDetail | null = null;
  selectedProducts: SelectedProduct[] = [];
  selectedCustomer: Customer | null = null;

  constructor(
    private loadService: LoadManagementService,
    private messageDialogService: MessageDialogService,
    private customerService: CustomerService
  ) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    this.startDate = today.toISOString().split('T')[0];
    this.endDate = tomorrow.toISOString().split('T')[0];
  }

  fetchLoads(): void {
    if (!this.startDate || !this.endDate) {
      this.messageDialogService.warning('Please select start and end dates.');
      return;
    }

    const payload = {
      startDate: this.startDate,
      endDate: this.endDate,
      page: this.page,
      page_size: this.pageSize
    };

    this.loadService.filterLoads(payload).subscribe((res) => {
      if (res.status === 'success' && res.loads) {
        this.loads = res.loads;
        this.totalPages = res.pages ?? 1;
      } else {
        this.loads = [];
        this.totalPages = 1;
      }
    });
  }

  viewLoadDetails(load: FilteredLoad) {
    this.loadService.getLoadById({ load_id: load.id }).subscribe(async (res) => {
      if (res.status !== 'success' || !res.load) {
        this.messageDialogService.error(res.message || 'Unable to load details');
        return;
      }

      this.selectedLoad = res.load;
      this.selectedProducts = res.load.saleOrders.map((line) => ({
        productId: line.id,
        quantity: line.numberOfItems,
        price: line.totalAmount // Note: adjust this if your cart expects unit price
      }));

      const customers = await firstValueFrom(this.customerService.get());
      const firstOrder = res.load.saleOrders[0];
      this.selectedCustomer = customers.find(c => c.id === firstOrder.customerId) ?? null;

      this.showCart = true;
    });
  }

  nextPage(): void {
    if (this.page < this.totalPages) {
      this.page++;
      this.fetchLoads();
    }
  }

  prevPage(): void {
    if (this.page > 1) {
      this.page--;
      this.fetchLoads();
    }
  }

  onReloadDetails() {
    this.showCart = false;
    this.fetchLoads();
  }
}
